import type { ReportLayoutWidget } from "@/app/app/_/views/ReportsView/ReportsView.utils";
import type {
  SharedViewWidget,
  SharedViewWidgetShell,
} from "@/app/share/report/sharedReportTypes";

export function resolveSharedWidgetIdentifier(
  widget: Pick<SharedViewWidgetShell, "identifier"> & {
    id?: string;
  },
  fallbackId?: string,
): string {
  return widget.identifier || widget.id || fallbackId || "";
}

export function buildSharedWidgetLookup(
  widgets: SharedViewWidget[],
): Map<string, SharedViewWidget> {
  const map = new Map<string, SharedViewWidget>();
  for (const widget of widgets) {
    const identifier = resolveSharedWidgetIdentifier(widget);
    if (identifier) {
      map.set(identifier, widget);
    }
    if (widget.source) {
      map.set(widget.source, widget);
    }
  }
  return map;
}

export function resolveSharedApiWidget(
  cardId: string,
  reportLayoutWidget: ReportLayoutWidget | undefined,
  lookup: Map<string, SharedViewWidget>,
): SharedViewWidget | undefined {
  const direct = lookup.get(cardId);
  if (direct) return direct;

  if (reportLayoutWidget) {
    const byLayoutWidgetId = lookup.get(reportLayoutWidget.id);
    if (byLayoutWidgetId) return byLayoutWidgetId;

    if (reportLayoutWidget.source) {
      const bySource = lookup.get(reportLayoutWidget.source);
      if (bySource) return bySource;
    }
  }

  return undefined;
}
